export default __webpack_public_path__ + "static/media/narigp.43f73a34.png";